import React, { useEffect, useState } from "react";
import { useAuth0Context } from "../../../context/Auth0Context";
import axios from "axios";
import { useAxiosContext } from "../../../context/AxiosContext";
import { GET_ASSETS_API, SM_TEMPLATES_API } from "../../../Api/StateMachine";
import Button from "../../../components/FormComponents/Button";
import { BASE_URL } from "../../../constant/constant";

const ImportSmTemplate = ({ handleStateMachineResponse }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [isLoader, setIsLoader] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [images, setImages] = useState([]);
  const { token } = useAuth0Context();
  const { axiosInstance, handleError } = useAxiosContext();

  const importTemplateHandler = async (template) => {
    try {
      const { data, message } = await axiosInstance.post("/state-machine/template", template);
      await handleStateMachineResponse(data, message);
      return true; // Success
    } catch (error) {
      handleError(error);
      return false; // Failure
    }
  };

  const buttonClickHandler = async () => {
    setIsLoading(true);

    const result = await importTemplateHandler(selectedTemplate);

    setIsLoading(result);
  };

  const getImage = async (imageName, appId) => {
    if (!imageName) return;

    try {
      const response = await axios.get(`${BASE_URL}/api/v1${GET_ASSETS_API}${imageName}`, {
        headers: {
          Authorization: token,
          "Zino-App-Id": appId
        },
        responseType: "arraybuffer"
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"]
      });
      const imageUrl = URL.createObjectURL(blob);

      setImages((prev) => [...prev, imageUrl]);
    } catch (error) {
      // handleError(error);
      console.log(error);
    }
  };

  const getSMTemplates = async () => {
    try {
      const { data } = await axiosInstance.get(SM_TEMPLATES_API);
      Promise.all(data.map((template) => getImage(template.image_path, template.app_id)));

      setTemplates(data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    getSMTemplates();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {templates.length ? (
        <>
          <div className="sm_template_container mt_2">
            <div>
              <div className="sm_template_grid">
                {templates.map((template, i) => (
                  <div
                    onClick={() => setSelectedTemplate(template)}
                    key={template.id}
                    className={"sm_template_card " + (template.id === selectedTemplate?.id ? " active" : " ")}
                  >
                    <img src={images[i]} className="sm_template_img" alt="" />
                    <p>{template.template_name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="sm_template_btn_container py_2">
            <Button
              onClick={() => buttonClickHandler(selectedTemplate)}
              disabled={selectedTemplate === null || isLoading}
            >
              Import
            </Button>
          </div>
        </>
      ) : (
        <div className="not_found_container" style={{ height: "50vh" }}>
          <p className="not_found_label">No Template found !</p>
        </div>
      )}
    </>
  );
};

export default ImportSmTemplate;
